import { IRootState } from '../../../../store'
import { IPnProcedureState } from '../store/pnProcedure.types'

export const getPnProcedureSelector = (state: IRootState): IPnProcedureState => state.pnProcedure
